import React, { useContext, useMemo } from 'react';
import context from '../../hoc/context/product/context';
import FormFactory from './form.factory';
import { FlowRouteProps } from '../flow/flow';
import { enrollmentContext } from '../../hoc/context/enrollment/enrollment-context';
import { EnrollmentLayout } from '../../hoc/components/layout/enrollment-layout';

interface FormProps extends FlowRouteProps {
	id?: string;
}

export default function FormComponent({ location, id, flow }: FormProps) {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const forms = useMemo(() => {
		return ctxt.json.getFilteredForms(
			enrollmentCtxt.input.performer,
			enrollmentCtxt.input.discardedServices,
			enrollmentCtxt.input.questions,
			enrollmentCtxt.input.consents
		);
	}, [enrollmentCtxt]);
	const form = forms[id ? +id - 1 : 0];

	return (
		<EnrollmentLayout
			label={form?.label}
			title={ctxt.json.pages.userProfile.header}
			mlrVersion={form?.mlrVersion}>
			{form && (
				<FormFactory
					form={form}
					next={() => flow.next(location!, { id: id })}
				/>
			)}
		</EnrollmentLayout>
	);
}
